import { Mask, View, Text, Button, Spinner } from '@smarterservices/smarter-ui';
import { getStore, usePlayerStore } from '../../../stores/StoreContext';

const Buffering = () => {
  const PlayerStore = getStore('playerStore');
  const smartSpeedEnabled = usePlayerStore((state) => state.smartSpeedEnabled);

  return (
    <Mask
      placement="center"
      themeOverride={{
        borderRadius: '0rem',
        background: 'rgba(255, 255, 255, .7)',
        zIndex: 7000,
      }}
    >
      <View width="400px"
        borderRadius="medium"
        background="primary-inverse"
        borderColor="primary"
        borderWidth="small"
        padding="medium">
        <Spinner size="small" variant="inverse" themeOverride={{ inverseColor: 'white' }} />
        <Text as="p" variant='descriptionPage'>Buffering Video...</Text>
        {!smartSpeedEnabled && (
          <View as="div" margin="medium 0">
            <Text as="p" variant='contentSmall'>Want to avoid buffering?</Text>
            <View as="div" margin="medium 0">
              <Text as="p" variant='contentSmall'>Switch to SmartSpeed to play as fast as possible and limit buffering.</Text>
              <Button size="small" margin="medium 0 0 0" onClick={() => PlayerStore.setSmartSpeedEnabled(true)}>Switch to SmartSpeed</Button>
            </View>
          </View>
        )}
      </View>
    </Mask >

  );
};

export default Buffering;
